import axios from 'axios';
import authToken from './authToken';
import cfac22 from '../cfac22';

export function generateQuote(payload) {
  return new Promise((resolve, reject) => {
    authToken().then((token) => {
      axios
        .post(
          cfac22('API_HOST_V2') +
            `/communicationMessages/generateQuote
            `,
          {
            ...payload,

            /*
            ex de body
            {
              "quotationsToMake": {
                 "sms": true
              },
              "communicationMessageId": "-OJU78gUps2aJzp7Ykg1",
              "filePath": "arquivosCotacoes/arquivoDeCotacaoTeste.csv"
              } */
          },
          {
            headers: { authorization: 'Bearer ' + token, 'Full-Url': window.location.href },
          }
        )
        .then((result) => {
          resolve(result.data.result);
        })
        .catch((error) => {
          return reject(error.response.data.error);
        });
    });
  });
}
